<a class="badge badge-primary mr-1 mb-1 text-capitalize"
   [routerLink]="searchLink"
   [queryParams]="(removeParameters | async)" queryParamsHandling="merge">
    {{('search.filters.applied.' + key) | translate}}: {{'search.filters.' + filterName + '.' + value | translate: {default: normalizeFilterValue(value)} }}
    <span> ×</span>
</a>
